import { DenominationEndpoints } from '@/modules/arbela-gift-card/denomination/api/denominatioEndpoints'

/**
 * Denomination endpoint instance
 * instantiate Denomination api class with different api path
 */
export const denominationEndpoints = new DenominationEndpoints()
